import type React from "react"

type Props = {
  legend: string
  children: React.ReactNode
}

export const Fieldset = ({ legend, children }: Props) => {
  return (
    <fieldset className="cobalt-Fieldset">
      <legend>{legend}</legend>
      {children}
    </fieldset>
  )
}
